import Layout from '../views/layout/Layout'
import { format, subDays } from 'date-fns'

export default {
  path: '/report',
  component: Layout,
  redirect: 'noredirect',
  name: 'report',
  meta: {
    title: '数据报表',
    elicon: 'el-icon-fa-bar-chart',
    roles: [],
  },
  children: [
    {
      path: 'material-point',
      name: 'report.material-point',
      to: {
        query: {
          time: [
            format(subDays(new Date(), 2), 'YYYY-MM-DD'),
            format(new Date(), 'YYYY-MM-DD'),
          ],
          agg_type: 'sum',
          page_size: 50,
          tz: '8',
          group_fields: ['creative_type'],
          search_fields: [
            'impression',
            'click',
            'install',
            'revenue',
            'ctr',
            'cvr',
            'ivr',
            'ecpm',
          ],
        },
      },
      component: () => import('@/views/report/material-point/index.vue'),
      meta: {
        title: '交互素材埋点统计',
        roles: ['report.playable-stat.list'],
      },
    },
  ],
}
